<div class="flex flex-col items-start justify-start h-full gap-y-4">
  <div class="bg-surface-gray-100 rounded-2xl p-4 w-full">
    <app-section-heading
      title="HEADER.NAVS.ABOUT_US.MAIN"
      titleClasses="text-xl"
      titleButtonClasses="!mb-2"
      description="HEADER.NAVS.ABOUT_US.DESCRIPTION"
      descriptionClasses="!text-sm"
    />
  </div>
  <img [src]="'about-menu.webp' | cdnUrl:'images/mega-menu/about-us'" alt="mega menu image" class="w-full"/>
</div>